import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function clamp(val: number, min: number, max: number) {
  return val > max ? max : val < min ? min : val;
}

export function toPercentage(val: number, min: number, max: number) {
  if (val < min) {
    val = min;
  } else if (val > max) {
    val = max;
  }

  const percentage = (val - min) / (max - min);

  return +percentage.toFixed(2);
}

export function getEuropeanTimezones(): { label: string; value: string }[] {
  const allTimeZones = Intl.supportedValuesOf('timeZone');

  return allTimeZones
    .filter((zone: string) => zone.startsWith('Europe/'))
    .map((zone: string) => ({
      value: zone,
      label: zone,
    }));
}

export const formatValueOrDefault = (
  value?: string | number | null,
  label?: string,
  defaultValue: string = '--'
): string => {
  return value != null ? `${value}${label ? ` ${label}` : ''}` : defaultValue;
};

export function isValidDate(d?: string | number | Date): boolean {
  if (d === undefined || d === null) return false;

  const date = d instanceof Date ? d : new Date(d);
  return !isNaN(date.getTime());
}
